import React, { useState } from 'react';
import SNR_BNFTS_V3_Header from '../../Includes/Layouts/ADV_3/SNR_BNFTS_V3_Header.js';
import SNR_BNFTS_V3_Main from '../../Includes/Layouts/ADV_3/SNR_BNFTS_V3_Main.js';
import AdtopiaLoadAP from '../../../Utility/AdtopiaLoadAP.js';
import { Months } from '../../../Constants/Constants.js';
import '../../../../src/assets/css/SNR_BNFTS_V3.scss';
import stickyBanner from '../../../../src/assets/SNR_BNFTS_V2/img/sticky-banner.jpg';
import AnchorAdv from '../../UI/AnchorAdv.js';

const SNR_BNFTS_V3 = () => {
  var now = new Date();
  const year = now.getFullYear();
  const date = now.getDate();
  const monthIndex = now.getMonth();
  const monthName = Months[monthIndex];
  const formatted = ` ${monthName} ${date}, ${year}`;
  return (
    <>
      <AdtopiaLoadAP pageType="AP" splitName="2025_art/senior_benefits/v3" />
      <div className="SNR_BNFTS_V3">
        <div className="h-top-bar">
          <div className="container">
            {/* <p>One major benefit you don't want to miss: You could be eligible for a car finance refund. Find out more
              inside.</p> */}
              <p>
              £Billions for Seniors Set Aside. May 25' Moratorium Announced. Act Now to Avoid Disappointment.
              <AnchorAdv
                dataId="HEADER_TEXT_LINKS"
                className="prequalify-link"
              > Click Here to Pre-qualify. </AnchorAdv>
              </p>
          </div>
        </div>
        <SNR_BNFTS_V3_Header />
        {/* <div className="sticky-banner">
          <img
            src={stickyBanner}
            alt="Sticky Banner"
            className="img-fluid d-none d-md-block"
          />
        </div> */}
        <SNR_BNFTS_V3_Main />
      </div>
    </>
  );
};

export default SNR_BNFTS_V3;
